import ITemplate from "../../../types/ITemplate";
import ITemplateService from "../../spi/ITemplateService";
import FirebaseService from "./FirebaseService";

export default class FirebaseTemplateService implements ITemplateService {

  async getTemplates(searchTerm: string, rowsPerPage: number, pageNumber: number): Promise<Array<ITemplate>> {
    let templates: Array<ITemplate> = [];
    try{
      const snapshot = await FirebaseService.getInstance()
                            .templates()
                            .get()
      
      snapshot.forEach((child:any) => {
        const template:ITemplate = child.data();
        template.uid = child.id;
        templates.push(template)
      });
    }
    catch(ex) {
      throw ex;
    }
    return templates;
  }

  async getTemplate(uid: string): Promise<ITemplate> {
    let template: ITemplate = {} as ITemplate;
    if (uid == undefined || uid == "") {
      return template
    }
    try {
      const snapshot = await FirebaseService.getInstance()
      .template(uid)
      .get();
      template = snapshot.data();
      template.uid = snapshot.id;
    }
    catch(ex) { 
      throw ex
    }
    return template 
  }

  async createTemplate(template: ITemplate): Promise<ITemplate> {
    let temp: ITemplate = {} as ITemplate;
    try{
      FirebaseService.getInstance().templates().doc().set(template);
      temp = template;
    }
    catch(ex) {
      throw ex;
    }
    return temp;
  }

  async updateTemplate(template: ITemplate): Promise<Boolean> {
    if (template == undefined)
      return false
    try {
      const { ...templateSnapshot } = template;
      await FirebaseService.getInstance()
              .template(template.uid)
              .update({
                ...templateSnapshot
              })
    }
    catch(ex) {
      throw ex;
    }
    return true;
  }

  async deleteTemplate (template: ITemplate): Promise<Boolean> {
    if (template.uid == undefined || template.uid == "") {
      return false
    }
    try {
      await FirebaseService.getInstance()
              .template(template.uid)
              .delete()
    }
    catch(ex) {
      throw ex
    }
    return true;
  }

  async getTemplateByCode (code: string): Promise<ITemplate> {
    let template: ITemplate = {} as ITemplate;
    if (code == undefined || code == "") {
      return template
    }
    try {
      const snapshot = await FirebaseService.getInstance()
      .templates()
      .where('code', '==', code)
      .limit(1)
      .get();
      if (!snapshot.empty) {
        snapshot.forEach((child:any) => {
          template = child.data();
          template.uid = child.id;
        });
      }
    }
    catch(ex) { 
      throw ex
    }
    return template 
  }

}